<mat-card *ngIf="file"
          id="{{idPrefix}}"
          class="smp-select-thumb-nail"
          matTooltip="{{ getFileTitle() }}"
          [ngClass]="{'upload-error': file.thumbnailStatus === fileStatus.ERROR, 'selected': selected, 'disabled-thumb': disabled || file.not_selectable, 'for-list': forList }"
          (dblclick)="selectFile()">

  <img *ngIf="file.thumbnailLink && file.fileType && file.fileType.category === fileCategory.PHOTO"
       [hidden]="!rendered"
       mat-card-image
       src="{{getReducedSizeFileLinkWithToken()}}"
       draggable="false"
       (load)="loaded()">

  <i *ngIf="(file.thumbnailLink || file.is_template) && file.fileType && file.fileType.category !== fileCategory.PHOTO"
     class="dr-fa-icon far {{file.fileType.faClass}} fa-2x">
  </i>

  <i *ngIf="file.thumbnailStatus === fileStatus.ERROR"
     class="dr-fa-icon far fa-file-excel fa-2x">
  </i>

  <mat-spinner *ngIf="!file.thumbnailLink || (file.fileType && file.fileType.category === fileCategory.PHOTO && file.thumbnailLink && !rendered)" [diameter]="20"></mat-spinner>

</mat-card>
